<template>
    <transition name="fade">

        <div>
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">How do you want to receive your loan proceeds?</h3>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>Manner of Release</label>
                                <select ref="manner_rel" class="form-control custom-select-sm" @change="selectedMR" v-model="formLoan.manner_rel" :class="{'is-invalid': $parent.submitting && $v.formLoan.manner_rel.$error}">
                                    <option :value="null" disabled selected>- Please Select -</option>
                                    <option v-for="data in filteredMR" :key="data.manner_rel_code" :value="data.manner_rel_code">{{data.manner_rel_desc}}</option>
                                </select>
                            </div>
                        </div>

                        <div v-if="formLoan.manner_rel">
                            <div class="card-header">
                                <h3 class="card-title bold">Kindly provide your account details below:</h3>
                            </div>
                            <div class="card-body">
                                <div class="form-group" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                    <label>Bank Name</label>
                                    <v-select placeholder="- Select -" label="bankname" :class="{'vs-invalid': $parent.submitting && $v.formLoan.bankname.$error }" :options="filteredBank" :reduce="bankname => bankname.bankname" :clearable="false" v-model="formLoan.bankname"></v-select>
                                </div>
                                <div class="form-group">
                                    <label for="">Account Name</label>
                                    <!-- <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.acctname" :class="{'is-invalid': $parent.submitting && $v.formLoan.acctname.$error}"> -->
                                    <input type="text" class="form-control form-control-sm text-uppercase" :value="formLoan.acctname" disabled v-if="formLoan.bt_code=='BT2020002' || formLoan.bt_code=='BT2020004'">
                                    <input type="text" class="form-control form-control-sm text-uppercase" v-else v-model="formLoan.acctname" :class="{'is-invalid': $parent.submitting && $v.formLoan.acctname.$error}">
                                    <em class="fs-14 danger">Note: Your account name was based on your profile. Please ensure that your profile details are correct.</em>
                                </div>

                                <div class="form-group" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                    <label for="">Account Number</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model="formLoan.acctno" @blur="unmaskAcctNo" :class="{'is-invalid': $parent.submitting && $v.formLoan.acctno.$error}">
                                </div>

                                <div class="form-group" v-if="formLoan.manner_rel =='GC' || formLoan.manner_rel =='PM'">
                                    <label for="">Registered Mobile Number</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.acctno" @blur="unmaskMoboNo" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="" :class="{'is-invalid': $parent.submitting && $v.formLoan.acctno.$error}">
                                    <em class="fs-13">Ex. (0912) 3456789</em>
                                    <p class="fs-13 danger m-0 p-0" v-if="$parent.submitting && $v.formLoan.acctno.$error">Not a valid Mobile Number</p>
                                </div>


                            </div>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-primary" @click="back()"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="checkProceeds">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Modal -->
            <div class="modal fade" id="checkModalMR" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Verification</h5>
                        </div>
                        <div class="modal-body text-justify">
                            <div class="alert alert-info2">
                                <p class="card-text text-justify pb-0 mb-0">This will require you to upload the required document as evidence of your account name and number (e.g. screenshots from online apps, bank-validated deposit slip, ATM card with account name and account number, Passbook, etc.) in Step 4</p>
                            </div>

                            <p>Kindly ensure that the bank account declared in this application is active and can accept fund transfers, that the account is in the name of the registered business owner or of the corporation, and that the account number is correct.
                                Inaccurate/incomplete information or misrepresentation will serve as grounds for denial of loan application.</p>
                            <p>Please review and confirm your bank account details below:</p>

                            <div class="form-group">
                                <label>Manner of Release</label>
                                <select ref="manner_rel" class="form-control custom-select-sm" disabled v-model="formLoan.manner_rel">
                                    <option :value="null" disabled selected>- Please Select -</option>
                                    <option v-for="data in filteredMR" :key="data.manner_rel_code" :value="data.manner_rel_code">{{data.manner_rel_desc}}</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                <label>Bank Name</label>
                                <input type="text" class="form-control form-control-sm" v-model="formLoan.bankname" disabled>
                            </div>
                            <div class="form-group">
                                <label for="">Account Name</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" :value="formLoan.acctname" disabled>
                            </div>

                            <div class="form-group" v-if="formLoan.manner_rel !='GC' && formLoan.manner_rel !='PM'">
                                <label for="">Account Number</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" disabled v-model="formLoan.acctno">
                            </div>

                            <div class="form-group" v-if="formLoan.manner_rel =='GC' || formLoan.manner_rel =='PM'">
                                <label for="">Registered Mobile Number</label>
                                <input type="text" class="form-control form-control-sm" disabled v-model="formLoan.acctno" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="">
                                <em class="fs-13">Ex. (0912) 3456789</em>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" @click="closeModalMR">Edit</button>
                            <button type="button" class="btn btn-primary" @click="next">I confirm</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal -->
        </div>
    </transition>
</template>
<script>
    //built-in jsons
    import suffix from '../../../json/suffix.json';
    import {
        required,
        minLength,
        requiredIf,
        helpers
    } from 'vuelidate/lib/validators';

    const validateIf = (prop, validator) =>
        helpers.withParams({
            type: 'validatedIf',
            prop
        }, function(value, parentVm) {
            return helpers.ref(prop, this, parentVm) ? validator(value) : true
        })

    export default {
        props: ['formLoan','user'],
        data() {
            return {
                manner: [],
                banks: [],
                checkAcctNo: null,
                suffix: suffix,

                bank_details: {
                    bankname: null,
                    acctname: null,
                    acctno: null,
                    manner_rel: null,
                    application_id: null,
                }

            }
        },

        validations: {
            formLoan: {
                manner_rel: {
                    required
                },
                bankname: {
                    required: requiredIf(function() {
                        return this.formLoan.manner_rel != "GC" && this.formLoan.manner_rel != "PM";
                    })
                },
                acctname: {
                    required
                },
                acctno: {
                    required,
                    minLength: validateIf('acctmobile', minLength(14))
                },
            },
        },
        created() {
            this.getLoanProceeds();

        },
        methods: {

            reminderPromt() {
                Swal.fire({
                    icon: "info",
                    title: "Reminder",
                    text: `Submission of incorrect bank or electronic money account information and the subsequent request for the correction of the same will be subject to a penalty charge of PhP1,000.00`,
                    allowOutsideClick: false,
                })
            },
            back() {
                this.$emit('back');
            },

            closeModalMR() {
                $('#checkModalMR').modal('hide');
            },
            next() {
                $('#checkModalMR').modal('hide');
                this.formLoan.acctno = this.checkAcctNo;
                this.$emit('next');
            },

            checkProceeds: _.debounce(function() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {} else {
                    $('#checkModalMR').modal('show');
                }
            }, 300),
                        accountName() {
                if (this.formLoan.acctname) {
                    return this.formLoan.acctname;
                } else {
                    if (this.formLoan.bt_code == 'BT2020001') {
                        let x = this.user[0];
                        let s = x.suffix_code;
                        let suffix = '';
                        if (s) {
                            suffix = this.suffix.find(i => i.suffix_code === s).suffix_desc;
                        }
                        return x['fname'] + ' ' + x['lname'] + ' ' + suffix;
                    } else {
                        return this.formLoan.business_name;
                    }
                }
            },

            selectedMR() {
                this.formLoan.acctno = null;
                this.formLoan.acctmobile = this.reqAcctNo;

                if (this.formLoan.manner_rel == 'FT') {
                    this.formLoan.bankname = 'LAND BANK OF THE PHILIPPINES';
                } else {
                    this.formLoan.bankname = null;
                }
            },
            inputAcctMobile() {
                let val = this.formLoan.acct_mobile;
                this.formLoan.acctno = val;
            },
            unmaskAcctNo() {
                let val = this.formLoan.acctno;
                if (val) {
                    this.checkAcctNo = val.replace(/[^a-zA-Z0-9]/g, "");
                }
            },
            unmaskMoboNo() {
                this.checkAcctNo = this.formLoan.acctno;
            },
            getLoanProceeds() {

                this.$parent.payloading = true;
                axios.get('/api/v2-ref-loan-proceed-b2c')
                    .then(res => {
                        let data = res.data
                        this.manner = data.manner;
                        this.banks = data.banks;

                        this.formLoan.acctname = this.accountName();
                        this.checkAcctNo = this.formLoan.acctno;
                        this.$parent.payloading = false;
                        this.formLoan.acctmobile = this.reqAcctNo; //adding properties on parent props

                        this.reminderPromt();
                    })
                    .catch(err => {
                        this.$parent.payloading = false;
                    })
            },

            setDataObj(temp, data) {
                let obj = {}
                for (var key in temp) {
                    // if (data[key]) {}
                    obj[key] = data[key];
                }
                return obj;
            },
        },
        computed: {
            reqAcctNo() {
                let required = false;
                if (this.formLoan.manner_rel == "GC" || this.formLoan.manner_rel == "PM") {
                    required = true
                }
                return required;
            },
            filteredBank() {
                let data_banks = this.banks;
                if (this.formLoan.manner_rel == "IP") {
                    let instapay_data = data_banks.filter(function(item) {
                        return item.instapay == 'Y';
                    });
                    return instapay_data;
                }
                if (this.formLoan.manner_rel == "PN") {
                    let pesonet_data = data_banks.filter(function(item) {
                        return item.pesonet == 'Y';
                    });
                    return pesonet_data;
                }

                if (this.formLoan.manner_rel == "FT") {
                    let bankname = [{
                        'bankname': 'LAND BANK OF THE PHILIPPINES'
                    }];
                    return bankname;
                }
                if (this.formLoan.manner_rel == "CC") {
                    let ft_data = data_banks.filter(function(item) {
                        return item.bankname == 'LAND BANK OF THE PHILIPPINES';
                    });
                    return ft_data;
                }
            },
            filteredMR() {
                let list = this.manner;
                let amount = this.formLoan.req_loan_amt * 1;
                let filter = null;
                if (amount > 50000) {
                    filter = list.filter(function(item) {
                        return item.manner_rel_code == 'FT' || item.manner_rel_code == 'PN';
                    });
                    return filter;
                } else if (amount <= 30000) {
                    return list;
                } else {

                    filter = list.filter(function(item) {
                        return item.manner_rel_code == 'FT' || item.manner_rel_code == 'PN' || item.manner_rel_code == 'IP';
                    });
                    return filter;
                }
            },
        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>